import axios from "axios";
import { baseUrl } from '../utils/config';

export const UserProfilePicture = {
    api: (() => {
        const instance = axios.create({ baseURL: baseUrl });
        instance.interceptors.request.use((config) => {
            const token = localStorage.getItem('auth_token');
            if (token) {
                config.headers = config.headers || {};
                (config.headers as any).Authorization = `Bearer ${token}`;
            }
            return config;
        });
        return instance;
    })(),

    // Ancien upload basé sur FormData (multipart/form-data)
    /*
    async uploadProfilePicture(type: string, id: number, file: File): Promise<any> {
        const formData = new FormData();
        formData.append('file', file);
        try {
            const response = await axios.post(`${baseUrl}/upload-photo/${type}/${id}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data;
        } catch (error: any) {
            console.error('Erreur lors de l\'envoi de la photo de profil:', error);
            throw error;
        }
    },
    */
    // Ancien get basé sur filename + blob
        /*
        async getProfilePicture(filename: string): Promise<any> {
            try {
                const response = await axios.get(`${baseUrl}/profile-picture/${encodeURIComponent(filename)}`, {
                    responseType: "blob",
                    headers: {
                        Accept: "image/*",
                    },
                });
                return response.data;
            } catch (error: any) {
                throw error.response?.data || error;
            }
        },
        */
       
    // ✅ Nouveau upload via base64
    async uploadProfilePicture(user_id: number, file: File): Promise<any> {
        const toBase64 = (file: File): Promise<string> =>
            new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => resolve(reader.result as string);
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });

        try {
            const image_base64 = await toBase64(file);
            const response = await this.api.post(`/user-images/upload`, {
                user_id,
                image_base64,
            });
            return response.data;
        } catch (error: any) {
            console.error("Erreur lors de l'envoi de l'image base64 :", error);
            throw error;
        }
    },

    

    // ✅ Nouveau get par user_id → base64
    async getProfilePicture(user_id: number): Promise<any> {
        try {
            const response = await this.api.get(`/user-images/${user_id}`);
            return response.data; // { id, user_id, image_base64, ... }
        } catch (error: any) {
            console.error("Erreur lors de la récupération de l'image :", error);
            throw error;
        }
    },

    // ✅ Ajout optionnel : delete image
    async deleteProfilePicture(user_id: number): Promise<any> {
        try {
            const response = await this.api.delete(`/user-images/${user_id}`);
            return response.data;
        } catch (error: any) {
            console.error("Erreur lors de la suppression de l'image :", error);
            throw error;
        }
    },
}
